import { getCSQGlobal } from '../services/analytics.service';
getCSQGlobal().push(["getSessionKey", {
        callback: (sessionKey) => {
            if (sessionKey) {
                const hiddenInput = document.querySelector('input[name="contact[csq_session_key]"]');
                if (hiddenInput) {
                    hiddenInput.value = sessionKey;
                }
                else {
                    console.warn('Hidden input element not found');
                }
            }
        }
    }]);
getCSQGlobal().push(["replay:link:generate", { withTimestamp: true }, (context) => {
        if (context.replayLink) {
            const hiddenInput = document.querySelector('input[name="contact[csq_session_replay_link]"]');
            if (hiddenInput) {
                hiddenInput.value = context.replayLink;
            }
            else {
                console.warn('Hidden input element not found');
            }
        }
    }]);
